const TASK_DATE_FORMAT = new Intl.DateTimeFormat("pt-BR", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  timeZone: "America/Sao_Paulo",
});

/** Display a task's own timestamp as a São Paulo calendar date. Missing or
 * invalid values stay unavailable; callers must not substitute another field.
 */
export function formatTaskDate(value: number | null | undefined): string | null {
  if (typeof value !== "number" || !Number.isFinite(value)) return null;
  const date = new Date(value);
  return Number.isFinite(date.getTime()) ? TASK_DATE_FORMAT.format(date) : null;
}
